import React from 'react';
import { Outlet, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Circle, 
  ArrowRightLeft, 
  ShieldCheck, 
  UserCog,
  LogOut
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <div style={{width: 32, height: 32, background: 'var(--accent)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <span style={{color: 'white', fontSize: 18, fontWeight: 'bold'}}>C</span>
        </div>
        <span className="text-gradient">CiruAdmin</span>
      </div>
      
      <nav>
        <NavLink to="/" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <LayoutDashboard size={20} />
          <span>Dashboard</span>
        </NavLink>
        <NavLink to="/users" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <Users size={20} />
          <span>Users</span>
        </NavLink>
        <NavLink to="/circles" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <Circle size={20} />
          <span>Circles</span>
        </NavLink>
        <NavLink to="/transactions" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <ArrowRightLeft size={20} />
          <span>Transactions</span>
        </NavLink>
        <NavLink to="/kyc" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <ShieldCheck size={20} />
          <span>KYC Reviews</span>
        </NavLink>
        <NavLink to="/admins" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <UserCog size={20} />
          <span>Admins</span>
        </NavLink>
      </nav>

      <div style={{marginTop: 'auto'}}>
        <button onClick={handleLogout} className="nav-link" style={{width: '100%', background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left'}}>
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

const Header = () => {
  return (
    <div className="header glass" style={{borderRadius: 0, borderTop: 0, borderLeft: 0, borderRight: 0}}>
      <div>
        <h2 style={{fontSize: 18, fontWeight: 500, color: 'var(--text-secondary)'}}>System Control Panel</h2>
      </div>
      <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
        <div style={{width: 36, height: 36, borderRadius: '50%', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <span style={{color: 'white', fontWeight: 600}}>A</span>
        </div>
        <div>
          <div style={{fontSize: 14, fontWeight: 600}}>Admin User</div>
          <div style={{fontSize: 12, color: 'var(--text-secondary)'}}>Superadmin</div>
        </div>
      </div>
    </div>
  );
};

export const Layout = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
